// Vite dispatches this window event when a lazily imported chunk, or one of its
// preloaded dependencies, fails to load (see Vite's `__vitePreload` helper). It
// fires for route components and `defineAsyncComponent` loaders alike.
export const VITE_PRELOAD_ERROR_EVENT = 'vite:preloadError'

export const CHUNK_LOAD_ERROR_INFRA_EVENT = '[infra:chunk-load-error]'

// Shown when a chunk failed but no new release explains it (a network error or
// a broken cached file), so the "New version available" modal would be wrong.
export const CHUNK_LOAD_ERROR_TOAST_MESSAGE = 'Part of the page failed to load. Refresh the page to try again.'
export const CHUNK_LOAD_ERROR_TOAST_TIMEOUT_MS = 10 * 1000
